<template>
  <div id="productProgress">
    <el-table border stripe :data="tableData" :expand-row-keys="expandKeys" @expand-change="handleExpand">
      <el-table-column type="expand">
        <template slot-scope="scope">
          <el-table
            v-loading="loadingTwo"
            border
            stripe
            :data="tableDataTwo"
            :expand-row-keys="expandKeysTwo"
            @expand-change="handleExpandTwo"
          >
            <el-table-column type="expand">
              <template slot-scope="scopeTwo">
                <el-table v-loading="loadingThree" border stripe :data="tableDataThree">
                  <el-table-column label="部件条码" width="180" align="center" prop="partsSn" show-overflow-tooltip />
                  <el-table-column label="部件编号" width="120" align="center" prop="partsNo" show-overflow-tooltip />
                  <el-table-column label="部件名称" prop="partsName" show-overflow-tooltip />
                  <el-table-column label="扫描人" width="80" align="center" prop="operatorName" />
                  <el-table-column label="扫描时间" width="140" align="center" prop="createTime" />
                </el-table>
              </template>
            </el-table-column>
            <el-table-column label="生产条码" align="left" prop="itemSn" />
            <el-table-column label="报工数量" width="80" align="center" prop="quantity" />
            <el-table-column label="报工人" width="80" align="center" prop="operatorName" />
            <el-table-column label="报工时间" width="140" align="center" prop="finishTime" />
          </el-table>
        </template>
      </el-table-column>
      <el-table-column label="派工单号" align="center" prop="billNo" width="120" show-overflow-tooltip />
      <el-table-column label="工单编号" align="center" prop="productionOrderNo" width="120" show-overflow-tooltip />
      <el-table-column label="工序名称" width="100" prop="processName" align="center" show-overflow-tooltip />
      <el-table-column label="物料编号" align="center" prop="materialNo" width="120" show-overflow-tooltip />
      <el-table-column label="物料名称" prop="materialName" show-overflow-tooltip />
      <el-table-column label="派工数量" align="center" prop="quantity" width="80" />
      <el-table-column label="报工数量" align="center" prop="scanQuantity" width="80" />
      <el-table-column align="center" label="最后一次报工时间" prop="lastScanTime" width="140" />
    </el-table>
  </div>
</template>

<script>
export default {
  // 工单信息
  props: {
    orderInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  data() {
    return {
      tableData: [],
      expandKeys: [],
      tableDataTwo: [],
      expandKeysTwo: [],
      tableDataThree: [],
      loadingTwo: false,
      loadingThree: false,
    };
  },

  mounted() {
    this.getFirstLevelData(this.orderInfo.pkid);
  },

  methods: {
    // 获取第一层数据
    getFirstLevelData(id) {
      this.$http.get("basic", `productionManage/prodProcess?id=${id}`).then((resp) => {
        if (resp.success) {
          resp.data.forEach((item) => {
            item.isExpanded = false;
          });
          this.tableData = resp.data;
        }
      });
    },

    // 展开第一层数据
    handleExpand(row) {
      row.isExpanded = !row.isExpanded;
      if (row.isExpanded) {
        this.expandKeys.push(row.processIndex);
        this.getSecondLevelData(this.orderInfo.pkid, row.processIndex);
      } else {
        const index = this.expandKeys.indexOf(row.processIndex);
        this.expandKeys.splice(index, 1);
      }
    },

    // 获取第二层数据
    getSecondLevelData(pkid, processIndex) {
      this.loadingTwo = true;
      this.$http
        .get("basic", `productionManage/prodProcessScan?id=${pkid}&processIndex=${processIndex}`)
        .then((resp) => {
          if (resp.success) {
            resp.data.forEach((item) => {
              item.isExpanded = false;
            });
            this.tableDataTwo = resp.data;
            this.loadingTwo = false;
          }
        })
        .catch(() => {
          this.loadingTwo = false;
        });
    },

    // 展开第二层数据
    handleExpandTwo(row) {
      row.isExpanded = !row.isExpanded;
      if (row.isExpanded) {
        this.expandKeysTwo.push(row.pkid);
        this.getThirdLevelData(this.orderInfo.pkid, row.processIndex, row.itemSn);
      } else {
        const index = this.expandKeysTwo.indexOf(row.pkid);
        this.expandKeysTwo.splice(index, 1);
      }
    },

    // 获取第三层数据
    getThirdLevelData(pkid, processIndex, itemSn) {
      this.loadingThree = true;
      this.$http
        .get("basic", `productionManage/prodProcessPartsScan?id=${pkid}&processIndex=${processIndex}&itemSn=${itemSn}`)
        .then((resp) => {
          if (resp.success) {
            this.tableDataThree = resp.data;
            this.loadingThree = false;
          }
        })
        .catch(() => {
          this.loadingThree = false;
        });
    },
  },
};
</script>

<style lang="scss">
#productProgress {
  .el-table__expanded-cell {
    padding: 10px;
  }
}
</style>
